import { render } from "./TableTeinte.vue?vue&type=template&id=41bd5062&ts=true"
import script from "./TableTeinte.vue?vue&type=script&lang=ts"
export * from "./TableTeinte.vue?vue&type=script&lang=ts"

import "./TableTeinte.vue?vue&type=style&index=0&id=41bd5062&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Digithia/app/internal/coprodex-color/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__